// extracted by mini-css-extract-plugin
module.exports = {"root":"style-module__root___lwK7Z","contactInfo":"style-module__contactInfo___1wKCH","logoholder":"style-module__logoholder___1hYo1","logo":"style-module__logo___k4hNR"};